/* AGB-Checkbox vor dem Checkout. Blocks every checkout entry in the theme until accepted,
   syncs all instances (cart page / popup / drawer) and stores the acceptance as cart attribute
   ("AGB akzeptiert" = timestamp) so it shows up on the order. */
(function () {
  if (customElements.get('revo-terms')) return;
  const KEY = 'revoTermsAccepted';
  const ATTR = 'AGB akzeptiert';
  const get = () => { try { return sessionStorage.getItem(KEY) === '1'; } catch (e) { return false; } };
  const set = (v) => { try { v ? sessionStorage.setItem(KEY, '1') : sessionStorage.removeItem(KEY); } catch (e) {} };

  function syncAll() {
    const ok = get();
    document.querySelectorAll('revo-terms .revo-terms__input').forEach((i) => (i.checked = ok));
    document.querySelectorAll('revo-terms').forEach((el) => { el.classList.toggle('is-accepted', ok); if (ok) el.hideError(); });
    document.documentElement.classList.toggle('revo-terms-accepted', ok);
  }

  function saveAttribute(ok) {
    const stamp = ok
      ? new Date().toLocaleString('de-DE', { timeZone: 'Europe/Berlin', dateStyle: 'short', timeStyle: 'medium' }) + ' (Europe/Berlin)'
      : '';
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { [ATTR]: stamp } }),
    }).catch(() => {});
  }

  class RevoTerms extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('.revo-terms__input');
      this.error = this.querySelector('.revo-terms__error');
      this.input.checked = get();
      this.classList.toggle('is-accepted', this.input.checked);
      this.input.addEventListener('change', () => {
        set(this.input.checked);
        syncAll();
        saveAttribute(this.input.checked);
      });
    }
    showError() {
      this.error.hidden = false;
      this.classList.remove('is-shaking');
      void this.offsetWidth;
      this.classList.add('is-shaking', 'has-error');
    }
    hideError() {
      if (this.error) this.error.hidden = true;
      this.classList.remove('has-error');
    }
  }
  customElements.define('revo-terms', RevoTerms);

  const isCheckout = (el) =>
    el && (el.matches('[name="checkout"], #CartDrawer-Checkout') ||
      (el.tagName === 'A' && /\/checkouts?(\/|\?|$)/.test(el.getAttribute('href') || '')));

  function block(e, source) {
    if (get() || !document.querySelector('revo-terms')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    // nearest checkbox in the same cart UI, otherwise the first visible one
    const scope = source.closest('#cart-notification, cart-drawer, .cart__footer, form, .drawer') || document;
    const target = scope.querySelector('revo-terms') || document.querySelector('revo-terms');
    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    target.showError();
    target.querySelector('.revo-terms__input').focus({ preventScroll: true });
  }

  // capture phase: runs before the theme's own checkout handlers
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[name="checkout"], #CartDrawer-Checkout, a[href*="/checkout"]');
    if (isCheckout(btn)) return block(e, btn);
    const gate = e.target.closest('.revo-terms-gate');
    if (gate && !get()) block(e, gate);
  }, true);
  document.addEventListener('submit', (e) => {
    const sub = e.submitter;
    if (sub && isCheckout(sub)) block(e, sub);
    else if (e.target.id === 'cart-notification-form') block(e, e.target);
  }, true);

  // re-rendered cart sections (Shopify section rendering) → keep state
  new MutationObserver(() => {
    document.querySelectorAll('revo-terms .revo-terms__input').forEach((i) => { if (i.checked !== get()) i.checked = get(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('DOMContentLoaded', syncAll);
  syncAll();
})();
